import React, { FunctionComponent } from 'react';
import { Typography } from 'ui-components';
import { Trans } from 'react-i18next';
import { InfoNoteData } from './InfoNote.types';

import useStyles from './InfoNote.style';

const InfoNote: FunctionComponent<InfoNoteData> = ({title, subtitle, icon, transNamespace, transKey, transValues}) => {

  const c = useStyles({});

  const renderSubtitle = () => (
    <Typography variant="body2" textColor="greys.60">
      {transNamespace && transKey ? (
        <Trans ns={transNamespace} i18nKey={transKey} values={transValues} />
      ) : (
        subtitle
      )}
    </Typography>
  );

  return (
    <div className={c.root}>
      <div className={c.iconWrapper}>
        {icon}
      </div>
      <div>
        <Typography className={c.title} fontWeight="bold">{title}</Typography>
        {renderSubtitle()}
      </div>
    </div>
  );
};

export { InfoNote };
